// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.19.1
// source: process_point_service.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Filter_ChildOrganizations, Location, Pagination, Pagination_Result, Timestamp } from "./base";
import { DeviceSelection } from "./device";
import { File } from "./file";
import { Struct, Value } from "./google/protobuf/struct";
import {
  ProcessPoint,
  ProcessPoint_Type,
  processPoint_TypeFromJSON,
  processPoint_TypeToNumber,
  ProcessPointSelection,
} from "./process_point";
import { TagSelection } from "./tag";
import { Value_Numeric_Rate } from "./value";

export const protobufPackage = "hiber.processpoint";

/** List the process points in your (selected) organization. */
export interface ListProcessPoints {
}

export enum ListProcessPoints_Sort {
  /** NAME_ASC - Sort alphabetically on the name of the process point, in ascending order. Default. */
  NAME_ASC = "NAME_ASC",
  /** NAME_DESC - Sort alphabetically on the name of the process point, in descending order. */
  NAME_DESC = "NAME_DESC",
  /** ACTIVITY - Sort process points on most recent activity first (e.g. newest value received). */
  ACTIVITY = "ACTIVITY",
  /** INACTIVITY - Sort process points on least recent activity first (e.g. longest no value received). */
  INACTIVITY = "INACTIVITY",
  /** TYPE_ASC - Sort alphabetically on the process point type, in ascending order. */
  TYPE_ASC = "TYPE_ASC",
  /** TYPE_DESC - Sort alphabetically on the process point type, in descending order. */
  TYPE_DESC = "TYPE_DESC",
  /** TAG_TYPE_WELL_ASC - Sort alphabetically on any tags of type 'well', in ascending order. */
  TAG_TYPE_WELL_ASC = "TAG_TYPE_WELL_ASC",
  /** TAG_TYPE_WELL_DESC - Sort alphabetically on any tags of type 'well', in descending order. */
  TAG_TYPE_WELL_DESC = "TAG_TYPE_WELL_DESC",
  /** TAG_TYPE_SITE_ASC - Sort alphabetically on any tags of type 'site', in ascending order. */
  TAG_TYPE_SITE_ASC = "TAG_TYPE_SITE_ASC",
  /** TAG_TYPE_SITE_DESC - Sort alphabetically on any tags of type 'site', in descending order. */
  TAG_TYPE_SITE_DESC = "TAG_TYPE_SITE_DESC",
  /** TAG_TYPE_PRODUCTION_AREA_ASC - Sort alphabetically on any tags of type 'production_area', in ascending order. */
  TAG_TYPE_PRODUCTION_AREA_ASC = "TAG_TYPE_PRODUCTION_AREA_ASC",
  /** TAG_TYPE_PRODUCTION_AREA_DESC - Sort alphabetically on any tags of type 'production_area', in descending order. */
  TAG_TYPE_PRODUCTION_AREA_DESC = "TAG_TYPE_PRODUCTION_AREA_DESC",
  UNRECOGNIZED = "UNRECOGNIZED",
}

export function listProcessPoints_SortFromJSON(object: any): ListProcessPoints_Sort {
  switch (object) {
    case 0:
    case "NAME_ASC":
      return ListProcessPoints_Sort.NAME_ASC;
    case 1:
    case "NAME_DESC":
      return ListProcessPoints_Sort.NAME_DESC;
    case 2:
    case "ACTIVITY":
      return ListProcessPoints_Sort.ACTIVITY;
    case 3:
    case "INACTIVITY":
      return ListProcessPoints_Sort.INACTIVITY;
    case 4:
    case "TYPE_ASC":
      return ListProcessPoints_Sort.TYPE_ASC;
    case 5:
    case "TYPE_DESC":
      return ListProcessPoints_Sort.TYPE_DESC;
    case 6:
    case "TAG_TYPE_WELL_ASC":
      return ListProcessPoints_Sort.TAG_TYPE_WELL_ASC;
    case 7:
    case "TAG_TYPE_WELL_DESC":
      return ListProcessPoints_Sort.TAG_TYPE_WELL_DESC;
    case 8:
    case "TAG_TYPE_SITE_ASC":
      return ListProcessPoints_Sort.TAG_TYPE_SITE_ASC;
    case 9:
    case "TAG_TYPE_SITE_DESC":
      return ListProcessPoints_Sort.TAG_TYPE_SITE_DESC;
    case 10:
    case "TAG_TYPE_PRODUCTION_AREA_ASC":
      return ListProcessPoints_Sort.TAG_TYPE_PRODUCTION_AREA_ASC;
    case 11:
    case "TAG_TYPE_PRODUCTION_AREA_DESC":
      return ListProcessPoints_Sort.TAG_TYPE_PRODUCTION_AREA_DESC;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ListProcessPoints_Sort.UNRECOGNIZED;
  }
}

export function listProcessPoints_SortToNumber(object: ListProcessPoints_Sort): number {
  switch (object) {
    case ListProcessPoints_Sort.NAME_ASC:
      return 0;
    case ListProcessPoints_Sort.NAME_DESC:
      return 1;
    case ListProcessPoints_Sort.ACTIVITY:
      return 2;
    case ListProcessPoints_Sort.INACTIVITY:
      return 3;
    case ListProcessPoints_Sort.TYPE_ASC:
      return 4;
    case ListProcessPoints_Sort.TYPE_DESC:
      return 5;
    case ListProcessPoints_Sort.TAG_TYPE_WELL_ASC:
      return 6;
    case ListProcessPoints_Sort.TAG_TYPE_WELL_DESC:
      return 7;
    case ListProcessPoints_Sort.TAG_TYPE_SITE_ASC:
      return 8;
    case ListProcessPoints_Sort.TAG_TYPE_SITE_DESC:
      return 9;
    case ListProcessPoints_Sort.TAG_TYPE_PRODUCTION_AREA_ASC:
      return 10;
    case ListProcessPoints_Sort.TAG_TYPE_PRODUCTION_AREA_DESC:
      return 11;
    case ListProcessPoints_Sort.UNRECOGNIZED:
    default:
      return -1;
  }
}

export interface ListProcessPoints_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /**
   * Select which process points to return.
   * Optional, when omitted or empty everything is included.
   */
  selection?:
    | ProcessPointSelection
    | undefined;
  /** Paginate through results. */
  pagination?:
    | Pagination
    | undefined;
  /** Sort the process points with the given sort options. */
  sortBy: ListProcessPoints_Sort[];
  /** Include process points from the selected child organizations. */
  childOrganizations?: Filter_ChildOrganizations | undefined;
}

export interface ListProcessPoints_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: ListProcessPoints_Request | undefined;
}

/** Create one or more process points in your (selected) organization. */
export interface CreateProcessPoint {
  name?: string | undefined;
  type?: ProcessPoint_Type | undefined;
  description?: string | undefined;
  notes?: string | undefined;
  timeZone?: string | undefined;
  expectedTransmissionRate?: Value_Numeric_Rate | undefined;
  metadata?: { [key: string]: any } | undefined;
  location?: Location | undefined;
  files: File[];
}

export interface CreateProcessPoint_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** ProcessPoints to create. */
  create: CreateProcessPoint[];
}

export interface CreateProcessPoint_Response {
  created: ProcessPoint[];
  request: CreateProcessPoint_Request | undefined;
}

/** Update one or more process points in your (selected) organization. */
export interface UpdateProcessPoint {
  updateName?: string | undefined;
  updateType?: ProcessPoint_Type | undefined;
  updateDescription?: string | undefined;
  updateNotes?: string | undefined;
  updateTimeZone?: string | undefined;
  updateExpectedTransmissionRate?: Value_Numeric_Rate | undefined;
  addMetadata: { [key: string]: any | undefined };
  addMetadataText: { [key: string]: string };
  removeMetadataKeys: string[];
  location?: Location | undefined;
  removeLocation?: boolean | undefined;
  addFiles: File[];
  deleteFiles: string[];
}

export interface UpdateProcessPoint_AddMetadataEntry {
  key: string;
  value: any | undefined;
}

export interface UpdateProcessPoint_AddMetadataTextEntry {
  key: string;
  value: string;
}

export interface UpdateProcessPoint_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to update. Not optional and cannot be empty. */
  selection:
    | ProcessPointSelection
    | undefined;
  /** The update to apply to the selected process points. */
  update:
    | UpdateProcessPoint
    | undefined;
  /**
   * Paginate through results (for the Response, not the actual update).
   * To get the next pages, use the List call with the same selection and pagination for the next page.
   */
  pagination?: Pagination | undefined;
}

export interface UpdateProcessPoint_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: UpdateProcessPoint_Request | undefined;
}

/** Delete process points in your (selected) organization. */
export interface DeleteProcessPoint {
}

export interface DeleteProcessPoint_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to delete. Not optional and cannot be empty. */
  selection: ProcessPointSelection | undefined;
}

export interface DeleteProcessPoint_Response {
  deleted: number;
  request: DeleteProcessPoint_Request | undefined;
}

/** Change the assigned tags for a selection of process points in your (selected) organization. */
export interface AssignProcessPointTags {
}

export interface AssignProcessPointTags_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to assign. Not optional and cannot be empty. */
  selection:
    | ProcessPointSelection
    | undefined;
  /** Select which tags to assign this process point to. */
  tags:
    | TagSelection
    | undefined;
  /**
   * Paginate through results (for the Response, not the actual update).
   * To get the next pages, use the List call with the same selection and pagination for the next page.
   */
  pagination?: Pagination | undefined;
}

export interface AssignProcessPointTags_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: AssignProcessPointTags_Request | undefined;
}

/** Change the assigned tags for a selection of process points in your (selected) organization. */
export interface UnassignProcessPointTags {
}

export interface UnassignProcessPointTags_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to unassign. Not optional and cannot be empty. */
  selection:
    | ProcessPointSelection
    | undefined;
  /** Select which tags to unassign this process point from. */
  tags:
    | TagSelection
    | undefined;
  /**
   * Paginate through results (for the Response, not the actual update).
   * To get the next pages, use the List call with the same selection and pagination for the next page.
   */
  pagination?: Pagination | undefined;
}

export interface UnassignProcessPointTags_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: UnassignProcessPointTags_Request | undefined;
}

/** Change the assigned devices for a selection of process points in your (selected) organization. */
export interface AssignProcessPointDevices {
}

export interface AssignProcessPointDevices_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to assign. Not optional and cannot be empty. */
  selection:
    | ProcessPointSelection
    | undefined;
  /** Select which devices to assign this process point to. */
  devices:
    | DeviceSelection
    | undefined;
  /**
   * Paginate through results (for the Response, not the actual update).
   * To get the next pages, use the List call with the same selection and pagination for the next page.
   */
  pagination?:
    | Pagination
    | undefined;
  /**
   * Time that the assignment should be active.
   * This sets the assignment to start in the past, but would not have effect in the past for assignments like
   * parsers and alarms (they will only be triggered for new messages / values).
   * It would however work for process points having access to device data.
   * This is not allowed to be a value in the future at the moment.
   */
  overrideTime?:
    | Timestamp
    | undefined;
  /**
   * Time that the assignment ended.
   * This marks the assignment as ended at the given moment in the past, but would not have effect in the past
   * for assignments like parsers and alarms (e.g. no alarm events are removed).
   * It would however work for process points having access to device data.
   * This is not allowed to be a value in the future at the moment.
   */
  endTime?: Timestamp | undefined;
}

export interface AssignProcessPointDevices_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: AssignProcessPointDevices_Request | undefined;
}

/** Change the assigned devices for a selection of process points in your (selected) organization. */
export interface UnassignProcessPointDevices {
}

export interface UnassignProcessPointDevices_Request {
  /** Pick the organization to use (/impersonate). If unset, your default organization is used. */
  organization?:
    | string
    | undefined;
  /** Select which process points to unassign. Not optional and cannot be empty. */
  selection:
    | ProcessPointSelection
    | undefined;
  /** Select which devices to unassign this process point from. */
  devices:
    | DeviceSelection
    | undefined;
  /**
   * Paginate through results (for the Response, not the actual update).
   * To get the next pages, use the List call with the same selection and pagination for the next page.
   */
  pagination?:
    | Pagination
    | undefined;
  /**
   * Time that the assignment ended.
   * This marks the assignment as ended at the given moment in the past, but would not have effect in the past
   * for assignments like parsers and alarms (e.g. no alarm events are removed).
   * It would however work for process points having access to device data.
   * This is not allowed to be a value in the future at the moment.
   */
  overrideTime?: Timestamp | undefined;
}

export interface UnassignProcessPointDevices_Response {
  processPoints: ProcessPoint[];
  pagination: Pagination_Result | undefined;
  request: UnassignProcessPointDevices_Request | undefined;
}

function createBaseListProcessPoints(): ListProcessPoints {
  return {};
}

export const ListProcessPoints = {
  encode(_: ListProcessPoints, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListProcessPoints {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListProcessPoints();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ListProcessPoints>): ListProcessPoints {
    return ListProcessPoints.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<ListProcessPoints>): ListProcessPoints {
    const message = createBaseListProcessPoints();
    return message;
  },
};

function createBaseListProcessPoints_Request(): ListProcessPoints_Request {
  return {
    organization: undefined,
    selection: undefined,
    pagination: undefined,
    sortBy: [],
    childOrganizations: undefined,
  };
}

export const ListProcessPoints_Request = {
  encode(message: ListProcessPoints_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(26).fork()).ldelim();
    }
    writer.uint32(34).fork();
    for (const v of message.sortBy) {
      writer.int32(listProcessPoints_SortToNumber(v));
    }
    writer.ldelim();
    if (message.childOrganizations !== undefined) {
      Filter_ChildOrganizations.encode(message.childOrganizations, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListProcessPoints_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListProcessPoints_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag === 32) {
            message.sortBy.push(listProcessPoints_SortFromJSON(reader.int32()));

            continue;
          }

          if (tag === 34) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.sortBy.push(listProcessPoints_SortFromJSON(reader.int32()));
            }

            continue;
          }

          break;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.childOrganizations = Filter_ChildOrganizations.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ListProcessPoints_Request>): ListProcessPoints_Request {
    return ListProcessPoints_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListProcessPoints_Request>): ListProcessPoints_Request {
    const message = createBaseListProcessPoints_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    message.sortBy = object.sortBy?.map((e) => e) || [];
    message.childOrganizations = (object.childOrganizations !== undefined && object.childOrganizations !== null)
      ? Filter_ChildOrganizations.fromPartial(object.childOrganizations)
      : undefined;
    return message;
  },
};

function createBaseListProcessPoints_Response(): ListProcessPoints_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const ListProcessPoints_Response = {
  encode(message: ListProcessPoints_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      ListProcessPoints_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListProcessPoints_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListProcessPoints_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = ListProcessPoints_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<ListProcessPoints_Response>): ListProcessPoints_Response {
    return ListProcessPoints_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ListProcessPoints_Response>): ListProcessPoints_Response {
    const message = createBaseListProcessPoints_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? ListProcessPoints_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseCreateProcessPoint(): CreateProcessPoint {
  return {
    name: undefined,
    type: undefined,
    description: undefined,
    notes: undefined,
    timeZone: undefined,
    expectedTransmissionRate: undefined,
    metadata: undefined,
    location: undefined,
    files: [],
  };
}

export const CreateProcessPoint = {
  encode(message: CreateProcessPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.name !== undefined) {
      writer.uint32(10).string(message.name);
    }
    if (message.type !== undefined) {
      writer.uint32(16).int32(processPoint_TypeToNumber(message.type));
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    if (message.notes !== undefined) {
      writer.uint32(34).string(message.notes);
    }
    if (message.timeZone !== undefined) {
      writer.uint32(42).string(message.timeZone);
    }
    if (message.expectedTransmissionRate !== undefined) {
      Value_Numeric_Rate.encode(message.expectedTransmissionRate, writer.uint32(50).fork()).ldelim();
    }
    if (message.metadata !== undefined) {
      Struct.encode(Struct.wrap(message.metadata), writer.uint32(58).fork()).ldelim();
    }
    if (message.location !== undefined) {
      Location.encode(message.location, writer.uint32(66).fork()).ldelim();
    }
    for (const v of message.files) {
      File.encode(v!, writer.uint32(74).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateProcessPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProcessPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = processPoint_TypeFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.notes = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.timeZone = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.expectedTransmissionRate = Value_Numeric_Rate.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.metadata = Struct.unwrap(Struct.decode(reader, reader.uint32()));
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.location = Location.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.files.push(File.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<CreateProcessPoint>): CreateProcessPoint {
    return CreateProcessPoint.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateProcessPoint>): CreateProcessPoint {
    const message = createBaseCreateProcessPoint();
    message.name = object.name ?? undefined;
    message.type = object.type ?? undefined;
    message.description = object.description ?? undefined;
    message.notes = object.notes ?? undefined;
    message.timeZone = object.timeZone ?? undefined;
    message.expectedTransmissionRate =
      (object.expectedTransmissionRate !== undefined && object.expectedTransmissionRate !== null)
        ? Value_Numeric_Rate.fromPartial(object.expectedTransmissionRate)
        : undefined;
    message.metadata = object.metadata ?? undefined;
    message.location = (object.location !== undefined && object.location !== null)
      ? Location.fromPartial(object.location)
      : undefined;
    message.files = object.files?.map((e) => File.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateProcessPoint_Request(): CreateProcessPoint_Request {
  return { organization: undefined, create: [] };
}

export const CreateProcessPoint_Request = {
  encode(message: CreateProcessPoint_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    for (const v of message.create) {
      CreateProcessPoint.encode(v!, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateProcessPoint_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProcessPoint_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.create.push(CreateProcessPoint.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<CreateProcessPoint_Request>): CreateProcessPoint_Request {
    return CreateProcessPoint_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateProcessPoint_Request>): CreateProcessPoint_Request {
    const message = createBaseCreateProcessPoint_Request();
    message.organization = object.organization ?? undefined;
    message.create = object.create?.map((e) => CreateProcessPoint.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCreateProcessPoint_Response(): CreateProcessPoint_Response {
  return { created: [], request: undefined };
}

export const CreateProcessPoint_Response = {
  encode(message: CreateProcessPoint_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.created) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.request !== undefined) {
      CreateProcessPoint_Request.encode(message.request, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CreateProcessPoint_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCreateProcessPoint_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.created.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.request = CreateProcessPoint_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<CreateProcessPoint_Response>): CreateProcessPoint_Response {
    return CreateProcessPoint_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CreateProcessPoint_Response>): CreateProcessPoint_Response {
    const message = createBaseCreateProcessPoint_Response();
    message.created = object.created?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.request = (object.request !== undefined && object.request !== null)
      ? CreateProcessPoint_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseUpdateProcessPoint(): UpdateProcessPoint {
  return {
    updateName: undefined,
    updateType: undefined,
    updateDescription: undefined,
    updateNotes: undefined,
    updateTimeZone: undefined,
    updateExpectedTransmissionRate: undefined,
    addMetadata: {},
    addMetadataText: {},
    removeMetadataKeys: [],
    location: undefined,
    removeLocation: undefined,
    addFiles: [],
    deleteFiles: [],
  };
}

export const UpdateProcessPoint = {
  encode(message: UpdateProcessPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.updateName !== undefined) {
      writer.uint32(10).string(message.updateName);
    }
    if (message.updateType !== undefined) {
      writer.uint32(16).int32(processPoint_TypeToNumber(message.updateType));
    }
    if (message.updateDescription !== undefined) {
      writer.uint32(26).string(message.updateDescription);
    }
    if (message.updateNotes !== undefined) {
      writer.uint32(34).string(message.updateNotes);
    }
    if (message.updateTimeZone !== undefined) {
      writer.uint32(42).string(message.updateTimeZone);
    }
    if (message.updateExpectedTransmissionRate !== undefined) {
      Value_Numeric_Rate.encode(message.updateExpectedTransmissionRate, writer.uint32(50).fork()).ldelim();
    }
    Object.entries(message.addMetadata).forEach(([key, value]) => {
      if (value !== undefined) {
        UpdateProcessPoint_AddMetadataEntry.encode({ key: key as any, value }, writer.uint32(58).fork()).ldelim();
      }
    });
    Object.entries(message.addMetadataText).forEach(([key, value]) => {
      UpdateProcessPoint_AddMetadataTextEntry.encode({ key: key as any, value }, writer.uint32(66).fork()).ldelim();
    });
    for (const v of message.removeMetadataKeys) {
      writer.uint32(74).string(v!);
    }
    if (message.location !== undefined) {
      Location.encode(message.location, writer.uint32(82).fork()).ldelim();
    }
    if (message.removeLocation !== undefined) {
      writer.uint32(88).bool(message.removeLocation);
    }
    for (const v of message.addFiles) {
      File.encode(v!, writer.uint32(98).fork()).ldelim();
    }
    for (const v of message.deleteFiles) {
      writer.uint32(106).string(v!);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateProcessPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProcessPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.updateName = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.updateType = processPoint_TypeFromJSON(reader.int32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.updateDescription = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.updateNotes = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.updateTimeZone = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.updateExpectedTransmissionRate = Value_Numeric_Rate.decode(reader, reader.uint32());
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          const entry7 = UpdateProcessPoint_AddMetadataEntry.decode(reader, reader.uint32());
          if (entry7.value !== undefined) {
            message.addMetadata[entry7.key] = entry7.value;
          }
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          const entry8 = UpdateProcessPoint_AddMetadataTextEntry.decode(reader, reader.uint32());
          if (entry8.value !== undefined) {
            message.addMetadataText[entry8.key] = entry8.value;
          }
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.removeMetadataKeys.push(reader.string());
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.location = Location.decode(reader, reader.uint32());
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.removeLocation = reader.bool();
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.addFiles.push(File.decode(reader, reader.uint32()));
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.deleteFiles.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UpdateProcessPoint>): UpdateProcessPoint {
    return UpdateProcessPoint.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProcessPoint>): UpdateProcessPoint {
    const message = createBaseUpdateProcessPoint();
    message.updateName = object.updateName ?? undefined;
    message.updateType = object.updateType ?? undefined;
    message.updateDescription = object.updateDescription ?? undefined;
    message.updateNotes = object.updateNotes ?? undefined;
    message.updateTimeZone = object.updateTimeZone ?? undefined;
    message.updateExpectedTransmissionRate =
      (object.updateExpectedTransmissionRate !== undefined && object.updateExpectedTransmissionRate !== null)
        ? Value_Numeric_Rate.fromPartial(object.updateExpectedTransmissionRate)
        : undefined;
    message.addMetadata = Object.entries(object.addMetadata ?? {}).reduce<{ [key: string]: any | undefined }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      },
      {},
    );
    message.addMetadataText = Object.entries(object.addMetadataText ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      },
      {},
    );
    message.removeMetadataKeys = object.removeMetadataKeys?.map((e) => e) || [];
    message.location = (object.location !== undefined && object.location !== null)
      ? Location.fromPartial(object.location)
      : undefined;
    message.removeLocation = object.removeLocation ?? undefined;
    message.addFiles = object.addFiles?.map((e) => File.fromPartial(e)) || [];
    message.deleteFiles = object.deleteFiles?.map((e) => e) || [];
    return message;
  },
};

function createBaseUpdateProcessPoint_AddMetadataEntry(): UpdateProcessPoint_AddMetadataEntry {
  return { key: "", value: undefined };
}

export const UpdateProcessPoint_AddMetadataEntry = {
  encode(message: UpdateProcessPoint_AddMetadataEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      Value.encode(Value.wrap(message.value), writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateProcessPoint_AddMetadataEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProcessPoint_AddMetadataEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = Value.unwrap(Value.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UpdateProcessPoint_AddMetadataEntry>): UpdateProcessPoint_AddMetadataEntry {
    return UpdateProcessPoint_AddMetadataEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProcessPoint_AddMetadataEntry>): UpdateProcessPoint_AddMetadataEntry {
    const message = createBaseUpdateProcessPoint_AddMetadataEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? undefined;
    return message;
  },
};

function createBaseUpdateProcessPoint_AddMetadataTextEntry(): UpdateProcessPoint_AddMetadataTextEntry {
  return { key: "", value: "" };
}

export const UpdateProcessPoint_AddMetadataTextEntry = {
  encode(message: UpdateProcessPoint_AddMetadataTextEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateProcessPoint_AddMetadataTextEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProcessPoint_AddMetadataTextEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UpdateProcessPoint_AddMetadataTextEntry>): UpdateProcessPoint_AddMetadataTextEntry {
    return UpdateProcessPoint_AddMetadataTextEntry.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProcessPoint_AddMetadataTextEntry>): UpdateProcessPoint_AddMetadataTextEntry {
    const message = createBaseUpdateProcessPoint_AddMetadataTextEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseUpdateProcessPoint_Request(): UpdateProcessPoint_Request {
  return { organization: undefined, selection: undefined, update: undefined, pagination: undefined };
}

export const UpdateProcessPoint_Request = {
  encode(message: UpdateProcessPoint_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.update !== undefined) {
      UpdateProcessPoint.encode(message.update, writer.uint32(26).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateProcessPoint_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProcessPoint_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.update = UpdateProcessPoint.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UpdateProcessPoint_Request>): UpdateProcessPoint_Request {
    return UpdateProcessPoint_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProcessPoint_Request>): UpdateProcessPoint_Request {
    const message = createBaseUpdateProcessPoint_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.update = (object.update !== undefined && object.update !== null)
      ? UpdateProcessPoint.fromPartial(object.update)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseUpdateProcessPoint_Response(): UpdateProcessPoint_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const UpdateProcessPoint_Response = {
  encode(message: UpdateProcessPoint_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      UpdateProcessPoint_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateProcessPoint_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateProcessPoint_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = UpdateProcessPoint_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UpdateProcessPoint_Response>): UpdateProcessPoint_Response {
    return UpdateProcessPoint_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UpdateProcessPoint_Response>): UpdateProcessPoint_Response {
    const message = createBaseUpdateProcessPoint_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? UpdateProcessPoint_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseDeleteProcessPoint(): DeleteProcessPoint {
  return {};
}

export const DeleteProcessPoint = {
  encode(_: DeleteProcessPoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteProcessPoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteProcessPoint();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<DeleteProcessPoint>): DeleteProcessPoint {
    return DeleteProcessPoint.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<DeleteProcessPoint>): DeleteProcessPoint {
    const message = createBaseDeleteProcessPoint();
    return message;
  },
};

function createBaseDeleteProcessPoint_Request(): DeleteProcessPoint_Request {
  return { organization: undefined, selection: undefined };
}

export const DeleteProcessPoint_Request = {
  encode(message: DeleteProcessPoint_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteProcessPoint_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteProcessPoint_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<DeleteProcessPoint_Request>): DeleteProcessPoint_Request {
    return DeleteProcessPoint_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteProcessPoint_Request>): DeleteProcessPoint_Request {
    const message = createBaseDeleteProcessPoint_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    return message;
  },
};

function createBaseDeleteProcessPoint_Response(): DeleteProcessPoint_Response {
  return { deleted: 0, request: undefined };
}

export const DeleteProcessPoint_Response = {
  encode(message: DeleteProcessPoint_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.deleted !== 0) {
      writer.uint32(8).uint32(message.deleted);
    }
    if (message.request !== undefined) {
      DeleteProcessPoint_Request.encode(message.request, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteProcessPoint_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDeleteProcessPoint_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.deleted = reader.uint32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.request = DeleteProcessPoint_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<DeleteProcessPoint_Response>): DeleteProcessPoint_Response {
    return DeleteProcessPoint_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DeleteProcessPoint_Response>): DeleteProcessPoint_Response {
    const message = createBaseDeleteProcessPoint_Response();
    message.deleted = object.deleted ?? 0;
    message.request = (object.request !== undefined && object.request !== null)
      ? DeleteProcessPoint_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseAssignProcessPointTags(): AssignProcessPointTags {
  return {};
}

export const AssignProcessPointTags = {
  encode(_: AssignProcessPointTags, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointTags {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointTags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointTags>): AssignProcessPointTags {
    return AssignProcessPointTags.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<AssignProcessPointTags>): AssignProcessPointTags {
    const message = createBaseAssignProcessPointTags();
    return message;
  },
};

function createBaseAssignProcessPointTags_Request(): AssignProcessPointTags_Request {
  return { organization: undefined, selection: undefined, tags: undefined, pagination: undefined };
}

export const AssignProcessPointTags_Request = {
  encode(message: AssignProcessPointTags_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.tags !== undefined) {
      TagSelection.encode(message.tags, writer.uint32(26).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointTags_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointTags_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.tags = TagSelection.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointTags_Request>): AssignProcessPointTags_Request {
    return AssignProcessPointTags_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AssignProcessPointTags_Request>): AssignProcessPointTags_Request {
    const message = createBaseAssignProcessPointTags_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.tags = (object.tags !== undefined && object.tags !== null)
      ? TagSelection.fromPartial(object.tags)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseAssignProcessPointTags_Response(): AssignProcessPointTags_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const AssignProcessPointTags_Response = {
  encode(message: AssignProcessPointTags_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      AssignProcessPointTags_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointTags_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointTags_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = AssignProcessPointTags_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointTags_Response>): AssignProcessPointTags_Response {
    return AssignProcessPointTags_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AssignProcessPointTags_Response>): AssignProcessPointTags_Response {
    const message = createBaseAssignProcessPointTags_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? AssignProcessPointTags_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseUnassignProcessPointTags(): UnassignProcessPointTags {
  return {};
}

export const UnassignProcessPointTags = {
  encode(_: UnassignProcessPointTags, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointTags {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointTags();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointTags>): UnassignProcessPointTags {
    return UnassignProcessPointTags.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<UnassignProcessPointTags>): UnassignProcessPointTags {
    const message = createBaseUnassignProcessPointTags();
    return message;
  },
};

function createBaseUnassignProcessPointTags_Request(): UnassignProcessPointTags_Request {
  return { organization: undefined, selection: undefined, tags: undefined, pagination: undefined };
}

export const UnassignProcessPointTags_Request = {
  encode(message: UnassignProcessPointTags_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.tags !== undefined) {
      TagSelection.encode(message.tags, writer.uint32(26).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointTags_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointTags_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.tags = TagSelection.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointTags_Request>): UnassignProcessPointTags_Request {
    return UnassignProcessPointTags_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnassignProcessPointTags_Request>): UnassignProcessPointTags_Request {
    const message = createBaseUnassignProcessPointTags_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.tags = (object.tags !== undefined && object.tags !== null)
      ? TagSelection.fromPartial(object.tags)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    return message;
  },
};

function createBaseUnassignProcessPointTags_Response(): UnassignProcessPointTags_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const UnassignProcessPointTags_Response = {
  encode(message: UnassignProcessPointTags_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      UnassignProcessPointTags_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointTags_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointTags_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = UnassignProcessPointTags_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointTags_Response>): UnassignProcessPointTags_Response {
    return UnassignProcessPointTags_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnassignProcessPointTags_Response>): UnassignProcessPointTags_Response {
    const message = createBaseUnassignProcessPointTags_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? UnassignProcessPointTags_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseAssignProcessPointDevices(): AssignProcessPointDevices {
  return {};
}

export const AssignProcessPointDevices = {
  encode(_: AssignProcessPointDevices, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointDevices {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointDevices();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointDevices>): AssignProcessPointDevices {
    return AssignProcessPointDevices.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<AssignProcessPointDevices>): AssignProcessPointDevices {
    const message = createBaseAssignProcessPointDevices();
    return message;
  },
};

function createBaseAssignProcessPointDevices_Request(): AssignProcessPointDevices_Request {
  return {
    organization: undefined,
    selection: undefined,
    devices: undefined,
    pagination: undefined,
    overrideTime: undefined,
    endTime: undefined,
  };
}

export const AssignProcessPointDevices_Request = {
  encode(message: AssignProcessPointDevices_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.devices !== undefined) {
      DeviceSelection.encode(message.devices, writer.uint32(26).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }
    if (message.overrideTime !== undefined) {
      Timestamp.encode(message.overrideTime, writer.uint32(42).fork()).ldelim();
    }
    if (message.endTime !== undefined) {
      Timestamp.encode(message.endTime, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointDevices_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointDevices_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.devices = DeviceSelection.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.overrideTime = Timestamp.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.endTime = Timestamp.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointDevices_Request>): AssignProcessPointDevices_Request {
    return AssignProcessPointDevices_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AssignProcessPointDevices_Request>): AssignProcessPointDevices_Request {
    const message = createBaseAssignProcessPointDevices_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.devices = (object.devices !== undefined && object.devices !== null)
      ? DeviceSelection.fromPartial(object.devices)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    message.overrideTime = (object.overrideTime !== undefined && object.overrideTime !== null)
      ? Timestamp.fromPartial(object.overrideTime)
      : undefined;
    message.endTime = (object.endTime !== undefined && object.endTime !== null)
      ? Timestamp.fromPartial(object.endTime)
      : undefined;
    return message;
  },
};

function createBaseAssignProcessPointDevices_Response(): AssignProcessPointDevices_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const AssignProcessPointDevices_Response = {
  encode(message: AssignProcessPointDevices_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      AssignProcessPointDevices_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AssignProcessPointDevices_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignProcessPointDevices_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = AssignProcessPointDevices_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<AssignProcessPointDevices_Response>): AssignProcessPointDevices_Response {
    return AssignProcessPointDevices_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<AssignProcessPointDevices_Response>): AssignProcessPointDevices_Response {
    const message = createBaseAssignProcessPointDevices_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? AssignProcessPointDevices_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

function createBaseUnassignProcessPointDevices(): UnassignProcessPointDevices {
  return {};
}

export const UnassignProcessPointDevices = {
  encode(_: UnassignProcessPointDevices, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointDevices {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointDevices();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointDevices>): UnassignProcessPointDevices {
    return UnassignProcessPointDevices.fromPartial(base ?? {});
  },
  fromPartial(_: DeepPartial<UnassignProcessPointDevices>): UnassignProcessPointDevices {
    const message = createBaseUnassignProcessPointDevices();
    return message;
  },
};

function createBaseUnassignProcessPointDevices_Request(): UnassignProcessPointDevices_Request {
  return {
    organization: undefined,
    selection: undefined,
    devices: undefined,
    pagination: undefined,
    overrideTime: undefined,
  };
}

export const UnassignProcessPointDevices_Request = {
  encode(message: UnassignProcessPointDevices_Request, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.organization !== undefined) {
      writer.uint32(10).string(message.organization);
    }
    if (message.selection !== undefined) {
      ProcessPointSelection.encode(message.selection, writer.uint32(18).fork()).ldelim();
    }
    if (message.devices !== undefined) {
      DeviceSelection.encode(message.devices, writer.uint32(26).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination.encode(message.pagination, writer.uint32(34).fork()).ldelim();
    }
    if (message.overrideTime !== undefined) {
      Timestamp.encode(message.overrideTime, writer.uint32(42).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointDevices_Request {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointDevices_Request();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.organization = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.selection = ProcessPointSelection.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.devices = DeviceSelection.decode(reader, reader.uint32());
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.pagination = Pagination.decode(reader, reader.uint32());
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.overrideTime = Timestamp.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointDevices_Request>): UnassignProcessPointDevices_Request {
    return UnassignProcessPointDevices_Request.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnassignProcessPointDevices_Request>): UnassignProcessPointDevices_Request {
    const message = createBaseUnassignProcessPointDevices_Request();
    message.organization = object.organization ?? undefined;
    message.selection = (object.selection !== undefined && object.selection !== null)
      ? ProcessPointSelection.fromPartial(object.selection)
      : undefined;
    message.devices = (object.devices !== undefined && object.devices !== null)
      ? DeviceSelection.fromPartial(object.devices)
      : undefined;
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination.fromPartial(object.pagination)
      : undefined;
    message.overrideTime = (object.overrideTime !== undefined && object.overrideTime !== null)
      ? Timestamp.fromPartial(object.overrideTime)
      : undefined;
    return message;
  },
};

function createBaseUnassignProcessPointDevices_Response(): UnassignProcessPointDevices_Response {
  return { processPoints: [], pagination: undefined, request: undefined };
}

export const UnassignProcessPointDevices_Response = {
  encode(message: UnassignProcessPointDevices_Response, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.processPoints) {
      ProcessPoint.encode(v!, writer.uint32(10).fork()).ldelim();
    }
    if (message.pagination !== undefined) {
      Pagination_Result.encode(message.pagination, writer.uint32(18).fork()).ldelim();
    }
    if (message.request !== undefined) {
      UnassignProcessPointDevices_Request.encode(message.request, writer.uint32(26).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnassignProcessPointDevices_Response {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnassignProcessPointDevices_Response();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.processPoints.push(ProcessPoint.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.pagination = Pagination_Result.decode(reader, reader.uint32());
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.request = UnassignProcessPointDevices_Request.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  create(base?: DeepPartial<UnassignProcessPointDevices_Response>): UnassignProcessPointDevices_Response {
    return UnassignProcessPointDevices_Response.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<UnassignProcessPointDevices_Response>): UnassignProcessPointDevices_Response {
    const message = createBaseUnassignProcessPointDevices_Response();
    message.processPoints = object.processPoints?.map((e) => ProcessPoint.fromPartial(e)) || [];
    message.pagination = (object.pagination !== undefined && object.pagination !== null)
      ? Pagination_Result.fromPartial(object.pagination)
      : undefined;
    message.request = (object.request !== undefined && object.request !== null)
      ? UnassignProcessPointDevices_Request.fromPartial(object.request)
      : undefined;
    return message;
  },
};

/**
 * Manage Process Points in your organization, creating new process points,
 * updating or deleting them in bulk and changing assigned tags and devices.
 */
export type ProcessPointServiceDefinition = typeof ProcessPointServiceDefinition;
export const ProcessPointServiceDefinition = {
  name: "ProcessPointService",
  fullName: "hiber.processpoint.ProcessPointService",
  methods: {
    /** List the process points in your organization. */
    list: {
      name: "List",
      requestType: ListProcessPoints_Request,
      requestStream: false,
      responseType: ListProcessPoints_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([61])] } },
    },
    /** Create process points in your organization. */
    create: {
      name: "Create",
      requestType: CreateProcessPoint_Request,
      requestStream: false,
      responseType: CreateProcessPoint_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([62])] } },
    },
    /** Update process points in your organization. */
    update: {
      name: "Update",
      requestType: UpdateProcessPoint_Request,
      requestStream: false,
      responseType: UpdateProcessPoint_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([62])] } },
    },
    /** Delete process points in your organization. */
    delete: {
      name: "Delete",
      requestType: DeleteProcessPoint_Request,
      requestStream: false,
      responseType: DeleteProcessPoint_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([62])] } },
    },
    /** Assign (a) tag(s) to an process point. */
    assignTag: {
      name: "AssignTag",
      requestType: AssignProcessPointTags_Request,
      requestStream: false,
      responseType: AssignProcessPointTags_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([61]), new Uint8Array([45])] } },
    },
    /** Unassign (a) tag(s) from an process point. */
    unassignTag: {
      name: "UnassignTag",
      requestType: UnassignProcessPointTags_Request,
      requestStream: false,
      responseType: UnassignProcessPointTags_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([61]), new Uint8Array([45])] } },
    },
    /** Assign (a) device(s) to an process point. */
    assignDevice: {
      name: "AssignDevice",
      requestType: AssignProcessPointDevices_Request,
      requestStream: false,
      responseType: AssignProcessPointDevices_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([61]), new Uint8Array([45]), new Uint8Array([10])] } },
    },
    /** Unassign (a) device(s) from an process point. */
    unassignDevice: {
      name: "UnassignDevice",
      requestType: UnassignProcessPointDevices_Request,
      requestStream: false,
      responseType: UnassignProcessPointDevices_Response,
      responseStream: false,
      options: { _unknownFields: { 8008: [new Uint8Array([61]), new Uint8Array([45]), new Uint8Array([10])] } },
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;
